var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueBannerGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 500,
    viewBox: "0 0 1512 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_77)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("line", {
    x1: -140,
    y1: 237.906,
    x2: 1371.58,
    y2: 237.906,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -140,
    y1: 399.274,
    x2: 1371.58,
    y2: 399.274,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -140,
    y1: 76.5358,
    x2: 1371.58,
    y2: 76.5358,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -140,
    y1: 479.959,
    x2: 1371.58,
    y2: 479.959,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -140,
    y1: 157.221,
    x2: 1371.58,
    y2: 157.221,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -140,
    y1: 318.589,
    x2: 1371.58,
    y2: 318.589,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 552.756,
    y1: -113.199,
    x2: 552.756,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.016,
    y1: -113.199,
    x2: 230.016,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 875.492,
    y1: -113.199,
    x2: 875.492,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1198.23,
    y1: -113.199,
    x2: 1198.23,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.6455,
    y1: -113.199,
    x2: 68.6454,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 714.122,
    y1: -113.199,
    x2: 714.122,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.386,
    y1: -113.199,
    x2: 391.386,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1036.86,
    y1: -113.199,
    x2: 1036.86,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1359.6,
    y1: -113.199,
    x2: 1359.6,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 633.439,
    y1: -113.199,
    x2: 633.439,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.699,
    y1: -113.199,
    x2: 310.698,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 956.179,
    y1: -113.199,
    x2: 956.179,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1278.92,
    y1: -113.199,
    x2: 1278.92,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149.333,
    y1: -113.199,
    x2: 149.333,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 794.809,
    y1: -113.199,
    x2: 794.809,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 472.069,
    y1: -113.199,
    x2: 472.069,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1117.55,
    y1: -113.199,
    x2: 1117.54,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440.29,
    y1: -113.199,
    x2: 1440.29,
    y2: 1054.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.248,
    y: 483.381,
    width: 80.2262,
    height: 79.0801,
    fill: "#19224A",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: -4,
    width: 80.2262,
    height: 79.0801,
    fill: "#19224A",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 80,
    width: 80.2262,
    height: 79.0801,
    fill: "#19224A",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: -11,
    y: 159,
    width: 80.2262,
    height: 79.0801,
    fill: "#19224A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 158,
    width: 80.2262,
    height: 79.0801,
    fill: "#19224A",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: -11,
    y: -3,
    width: 80.2262,
    height: 79.0801,
    fill: "#434FAA",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 159,
    width: 80.2262,
    height: 79.0801,
    fill: "#434FAA",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1199,
    y: 78,
    width: 80,
    height: 80,
    fill: "#434FAA",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.277,
    y: 311.286,
    width: 80.2262,
    height: 79.0801,
    fill: "#19224A",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1332,
    y: 181,
    width: 80.2262,
    height: 80.2262,
    fill: "#19224A",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.37088,
    y: 482.381,
    width: 80.2262,
    height: 79.5062,
    fill: "#19224A",
    fillOpacity: 0.15
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_77"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBannerGrid);
export default __webpack_public_path__ + "static/media/blueBannerGrid.585fd58e06226531fb5159a9a2c67a82.svg";
export { ForwardRef as ReactComponent };